import styled from 'styled-components';

export const ToggleWrapper = styled('div')`
  margin-right: ${({ theme }) => theme.x1spacePx}px;
`;
export const ToggleLabel = styled('span')`
  opacity: 50%;
  font-size: 1.2rem;
`;

interface HiddenProps {
  hidden?: boolean;
}

export const MultiplesWrapper = styled('div')<HiddenProps>`
  ${({ hidden }) => hidden && 'visibility: hidden;'}
`;

export const OthersWrapper = styled('div')<HiddenProps>`
  ${({ hidden }) => hidden && 'visibility: hidden;'}
  min-height: 326px;
`;
